export const table = {
    wrapper: {
        style: {
            borderRadius: "8px",
        }
    },

    headline: {
        level: 5
    },
}